"use strict";

require("core-js/modules/es.array.reduce.js");

function t(t) {
  return t && "object" == typeof t && "default" in t ? t.default : t;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e,
    n,
    r,
    o,
    i = t(require("jsbi")),
    u = t(require("tiny-invariant")),
    a = (t(require("tiny-warning")), require("@ethersproject/address")),
    s = t(require("big.js")),
    c = t(require("toformat")),
    d = t(require("decimal.js-light")),
    f = require("@ethersproject/solidity"),
    l = require("@ethersproject/contracts"),
    p = require("@ethersproject/networks"),
    h = require("@ethersproject/providers"),
    m = t(require("@uniswap/v2-core/build/IUniswapV2Pair.json"));

(n = exports.ChainId || (exports.ChainId = {}))[n.MUMBAI = 80001] = "MUMBAI", n[n.MATIC = 137] = "MATIC", (r = exports.TradeType || (exports.TradeType = {}))[r.EXACT_INPUT = 0] = "EXACT_INPUT", r[r.EXACT_OUTPUT = 1] = "EXACT_OUTPUT", (o = exports.Rounding || (exports.Rounding = {}))[o.ROUND_DOWN = 0] = "ROUND_DOWN", o[o.ROUND_HALF_UP = 1] = "ROUND_HALF_UP", o[o.ROUND_UP = 2] = "ROUND_UP";
var v,
    y = "0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f",
    w = i.BigInt(1e3),
    T = i.BigInt(0),
    g = i.BigInt(1),
    k = i.BigInt(2),
    A = i.BigInt(3),
    x = i.BigInt(5),
    I = i.BigInt(10),
    b = i.BigInt(100),
    O = i.BigInt(997),
    q = i.BigInt(1e3);
!function (t) {
  t.uint8 = "uint8", t.uint256 = "uint256";
}(v || (v = {}));
var E = ((e = {})[v.uint8] = i.BigInt("0xff"), e[v.uint256] = i.BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), e);

function U(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}

function C(t, e, n) {
  return e && U(t.prototype, e), n && U(t, n), t;
}

function P() {
  return (P = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  }).apply(this, arguments);
}

function _(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}

function R(t) {
  return (R = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}

function N(t, e) {
  return (N = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}

function D() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (t) {
    return !1;
  }
}

function F(t, e, n) {
  return (F = D() ? Reflect.construct : function (t, e, n) {
    var r = [null];
    r.push.apply(r, e);
    var o = new (Function.bind.apply(t, r))();
    return n && N(o, n.prototype), o;
  }).apply(null, arguments);
}

function S(t) {
  var e = "function" == typeof Map ? new Map() : void 0;
  return (S = function S(t) {
    if (null === t || -1 === Function.toString.call(t).indexOf("[native code]")) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

    if (void 0 !== e) {
      if (e.has(t)) return e.get(t);
      e.set(t, n);
    }

    function n() {
      return F(t, arguments, R(this).constructor);
    }

    return n.prototype = Object.create(t.prototype, {
      constructor: {
        value: n,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), N(n, t);
  })(t);
}

function B(t) {
  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}

function M(t, e) {
  (null == e || e > t.length) && (e = t.length);

  for (var n = 0, r = new Array(e); n < e; n++) {
    r[n] = t[n];
  }

  return r;
}

function j(t, e) {
  var n;

  if ("undefined" == typeof Symbol || null == t[Symbol.iterator]) {
    if (Array.isArray(t) || (n = function (t, e) {
      if (t) {
        if ("string" == typeof t) return M(t, void 0);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? M(t, void 0) : void 0;
      }
    }(t)) || e && t && "number" == typeof t.length) {
      n && (t = n);
      var r = 0;
      return function () {
        return r >= t.length ? {
          done: !0
        } : {
          done: !1,
          value: t[r++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  return (n = t[Symbol.iterator]()).next.bind(n);
}

var H = ("setPrototypeOf" in Object),
    X = function (t) {
  function e() {
    var n;
    return (n = t.call(this) || this).isInsufficientReservesError = !0, n.name = n.constructor.name, H && Object.setPrototypeOf(B(n), (this instanceof e ? this.constructor : void 0).prototype), n;
  }

  return _(e, t), e;
}(S(Error)),
    L = function (t) {
  function e() {
    var n;
    return (n = t.call(this) || this).isInsufficientInputAmountError = !0, n.name = n.constructor.name, H && Object.setPrototypeOf(B(n), (this instanceof e ? this.constructor : void 0).prototype), n;
  }

  return _(e, t), e;
}(S(Error));

function W(t, e) {
  i.greaterThanOrEqual(t, T) || u(!1), i.lessThanOrEqual(t, E[e]) || u(!1);
}

function V(t) {
  try {
    return a.getAddress(t);
  } catch (t) {
    u(!1);
  }
}

function Y(t) {
  return t instanceof i ? t : i.BigInt("bigint" == typeof t ? t.toString() : t);
}

function J(t) {
  W(t, v.uint256);
  var e,
      n = T;
  if (i.greaterThan(t, A)) for (n = t, e = i.add(i.divide(t, k), g); i.lessThan(e, n);) {
    n = e, e = i.divide(i.add(i.divide(t, e), e), k);
  } else i.notEqual(t, T) && (n = g);
  return n;
}

function Q(t, e, n, r) {
  if (n > 0 || u(!1), t.length <= n || u(!1), 0 === t.length) return t.push(e), null;
  var o = t.length === n;
  if (o && r(t[t.length - 1], e) <= 0) return e;

  for (var i = 0, a = t.length; i < a;) {
    var s = i + a >>> 1;
    r(t[s], e) <= 0 ? i = s + 1 : a = s;
  }

  return t.splice(i, 0, e), o ? t.pop() : null;
}

var $,
    z = function z(t, e, n) {
  W(i.BigInt(t), v.uint8), this.decimals = t, this.symbol = e, this.name = n;
},
    G = z.ETHER = new z(18, "MATIC", "Matic"),
    K = function (t) {
  function e(e, n, r, o, i) {
    var u;
    return (u = t.call(this, r, o, i) || this).chainId = e, u.address = V(n), u;
  }

  _(e, t);

  var n = e.prototype;
  return n.equals = function (t) {
    return this === t || this.chainId === t.chainId && this.address === t.address;
  }, n.sortsBefore = function (t) {
    return this.chainId !== t.chainId && u(!1), this.address === t.address && u(!1), this.address.toLowerCase() < t.address.toLowerCase();
  }, e;
}(z);

function Z(t, e) {
  return t instanceof K && e instanceof K ? t.equals(e) : !(t instanceof K || e instanceof K || t !== e);
}

var tt,
    et,
    nt = (($ = {})[exports.ChainId.MUMBAI] = new K(exports.ChainId.MUMBAI, "0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889", 18, "WMATIC", "Wrapped Matic"), $[exports.ChainId.MATIC] = new K(exports.ChainId.MATIC, "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270", 18, "WMATIC", "Wrapped Matic"), $),
    rt = c(d),
    ot = c(s),
    it = ((tt = {})[exports.Rounding.ROUND_DOWN] = rt.ROUND_DOWN, tt[exports.Rounding.ROUND_HALF_UP] = rt.ROUND_HALF_UP, tt[exports.Rounding.ROUND_UP] = rt.ROUND_UP, tt),
    ut = ((et = {})[exports.Rounding.ROUND_DOWN] = 0, et[exports.Rounding.ROUND_HALF_UP] = 1, et[exports.Rounding.ROUND_UP] = 3, et),
    at = function () {
  function t(t, e) {
    void 0 === e && (e = g), this.numerator = Y(t), this.denominator = Y(e);
  }

  var e = t.prototype;
  return e.invert = function () {
    return new t(this.denominator, this.numerator);
  }, e.add = function (e) {
    var n = e instanceof t ? e : new t(Y(e));
    return i.equal(this.denominator, n.denominator) ? new t(i.add(this.numerator, n.numerator), this.denominator) : new t(i.add(i.multiply(this.numerator, n.denominator), i.multiply(n.numerator, this.denominator)), i.multiply(this.denominator, n.denominator));
  }, e.subtract = function (e) {
    var n = e instanceof t ? e : new t(Y(e));
    return i.equal(this.denominator, n.denominator) ? new t(i.subtract(this.numerator, n.numerator), this.denominator) : new t(i.subtract(i.multiply(this.numerator, n.denominator), i.multiply(n.numerator, this.denominator)), i.multiply(this.denominator, n.denominator));
  }, e.lessThan = function (e) {
    var n = e instanceof t ? e : new t(Y(e));
    return i.lessThan(i.multiply(this.numerator, n.denominator), i.multiply(n.numerator, this.denominator));
  }, e.equalTo = function (e) {
    var n = e instanceof t ? e : new t(Y(e));
    return i.equal(i.multiply(this.numerator, n.denominator), i.multiply(n.numerator, this.denominator));
  }, e.greaterThan = function (e) {
    var n = e instanceof t ? e : new t(Y(e));
    return i.greaterThan(i.multiply(this.numerator, n.denominator), i.multiply(n.numerator, this.denominator));
  }, e.multiply = function (e) {
    var n = e instanceof t ? e : new t(Y(e));
    return new t(i.multiply(this.numerator, n.numerator), i.multiply(this.denominator, n.denominator));
  }, e.divide = function (e) {
    var n = e instanceof t ? e : new t(Y(e));
    return new t(i.multiply(this.numerator, n.denominator), i.multiply(this.denominator, n.numerator));
  }, e.toSignificant = function (t, e, n) {
    void 0 === e && (e = {
      groupSeparator: ""
    }), void 0 === n && (n = exports.Rounding.ROUND_HALF_UP), Number.isInteger(t) || u(!1), t > 0 || u(!1), rt.set({
      precision: t + 1,
      rounding: it[n]
    });
    var r = new rt(this.numerator.toString()).div(this.denominator.toString()).toSignificantDigits(t);
    return r.toFormat(r.decimalPlaces(), e);
  }, e.toFixed = function (t, e, n) {
    return void 0 === e && (e = {
      groupSeparator: ""
    }), void 0 === n && (n = exports.Rounding.ROUND_HALF_UP), Number.isInteger(t) || u(!1), t >= 0 || u(!1), ot.DP = t, ot.RM = ut[n], new ot(this.numerator.toString()).div(this.denominator.toString()).toFormat(t, e);
  }, C(t, [{
    key: "quotient",
    get: function get() {
      return i.divide(this.numerator, this.denominator);
    }
  }, {
    key: "remainder",
    get: function get() {
      return new t(i.remainder(this.numerator, this.denominator), this.denominator);
    }
  }]), t;
}(),
    st = c(s),
    ct = function (t) {
  function e(e, n) {
    var r,
        o = Y(n);
    return W(o, v.uint256), (r = t.call(this, o, i.exponentiate(I, i.BigInt(e.decimals))) || this).currency = e, r;
  }

  _(e, t), e.ether = function (t) {
    return new e(G, t);
  };
  var n = e.prototype;
  return n.add = function (t) {
    return Z(this.currency, t.currency) || u(!1), new e(this.currency, i.add(this.raw, t.raw));
  }, n.subtract = function (t) {
    return Z(this.currency, t.currency) || u(!1), new e(this.currency, i.subtract(this.raw, t.raw));
  }, n.toSignificant = function (e, n, r) {
    return void 0 === e && (e = 6), void 0 === r && (r = exports.Rounding.ROUND_DOWN), t.prototype.toSignificant.call(this, e, n, r);
  }, n.toFixed = function (e, n, r) {
    return void 0 === e && (e = this.currency.decimals), void 0 === r && (r = exports.Rounding.ROUND_DOWN), e <= this.currency.decimals || u(!1), t.prototype.toFixed.call(this, e, n, r);
  }, n.toExact = function (t) {
    return void 0 === t && (t = {
      groupSeparator: ""
    }), st.DP = this.currency.decimals, new st(this.numerator.toString()).div(this.denominator.toString()).toFormat(t);
  }, C(e, [{
    key: "raw",
    get: function get() {
      return this.numerator;
    }
  }]), e;
}(at),
    dt = function (t) {
  function e(e, n) {
    var r;
    return (r = t.call(this, e, n) || this).token = e, r;
  }

  _(e, t);

  var n = e.prototype;
  return n.add = function (t) {
    return this.token.equals(t.token) || u(!1), new e(this.token, i.add(this.raw, t.raw));
  }, n.subtract = function (t) {
    return this.token.equals(t.token) || u(!1), new e(this.token, i.subtract(this.raw, t.raw));
  }, e;
}(ct),
    ft = function (t) {
  function e(e, n, r, o) {
    var u;
    return (u = t.call(this, o, r) || this).baseCurrency = e, u.quoteCurrency = n, u.scalar = new at(i.exponentiate(I, i.BigInt(e.decimals)), i.exponentiate(I, i.BigInt(n.decimals))), u;
  }

  _(e, t), e.fromRoute = function (t) {
    for (var n, r = [], o = j(t.pairs.entries()); !(n = o()).done;) {
      var i = n.value,
          u = i[1];
      r.push(t.path[i[0]].equals(u.token0) ? new e(u.reserve0.currency, u.reserve1.currency, u.reserve0.raw, u.reserve1.raw) : new e(u.reserve1.currency, u.reserve0.currency, u.reserve1.raw, u.reserve0.raw));
    }

    return r.slice(1).reduce(function (t, e) {
      return t.multiply(e);
    }, r[0]);
  };
  var n = e.prototype;
  return n.invert = function () {
    return new e(this.quoteCurrency, this.baseCurrency, this.numerator, this.denominator);
  }, n.multiply = function (n) {
    Z(this.quoteCurrency, n.baseCurrency) || u(!1);
    var r = t.prototype.multiply.call(this, n);
    return new e(this.baseCurrency, n.quoteCurrency, r.denominator, r.numerator);
  }, n.quote = function (e) {
    return Z(e.currency, this.baseCurrency) || u(!1), this.quoteCurrency instanceof K ? new dt(this.quoteCurrency, t.prototype.multiply.call(this, e.raw).quotient) : ct.ether(t.prototype.multiply.call(this, e.raw).quotient);
  }, n.toSignificant = function (t, e, n) {
    return void 0 === t && (t = 6), this.adjusted.toSignificant(t, e, n);
  }, n.toFixed = function (t, e, n) {
    return void 0 === t && (t = 4), this.adjusted.toFixed(t, e, n);
  }, C(e, [{
    key: "raw",
    get: function get() {
      return new at(this.numerator, this.denominator);
    }
  }, {
    key: "adjusted",
    get: function get() {
      return t.prototype.multiply.call(this, this.scalar);
    }
  }]), e;
}(at),
    lt = {},
    pt = function () {
  function t(e, n) {
    var r = e.token.sortsBefore(n.token) ? [e, n] : [n, e];
    this.liquidityToken = new K(r[0].token.chainId, t.getAddress(r[0].token, r[1].token), 18, "UNI-V2", "Uniswap V2"), this.tokenAmounts = r;
  }

  t.getAddress = function (t, e) {
    var n,
        r,
        o,
        i,
        u,
        s = t.sortsBefore(e) ? [t, e] : [e, t];
    return void 0 === (null === (n = lt) || void 0 === n || null === (r = n[s[0].address]) || void 0 === r ? void 0 : r[s[1].address]) && (lt = P({}, lt, ((u = {})[s[0].address] = P({}, null === (o = lt) || void 0 === o ? void 0 : o[s[0].address], ((i = {})[s[1].address] = a.getCreate2Address("0x5757371414417b8C6CAad45bAeF941aBc7d3Ab32", f.keccak256(["bytes"], [f.pack(["address", "address"], [s[0].address, s[1].address])]), y), i)), u))), lt[s[0].address][s[1].address];
  };

  var e = t.prototype;
  return e.involvesToken = function (t) {
    return t.equals(this.token0) || t.equals(this.token1);
  }, e.priceOf = function (t) {
    return this.involvesToken(t) || u(!1), t.equals(this.token0) ? this.token0Price : this.token1Price;
  }, e.reserveOf = function (t) {
    return this.involvesToken(t) || u(!1), t.equals(this.token0) ? this.reserve0 : this.reserve1;
  }, e.getOutputAmount = function (e) {
    if (this.involvesToken(e.token) || u(!1), i.equal(this.reserve0.raw, T) || i.equal(this.reserve1.raw, T)) throw new X();
    var n = this.reserveOf(e.token),
        r = this.reserveOf(e.token.equals(this.token0) ? this.token1 : this.token0),
        o = i.multiply(e.raw, O),
        a = i.multiply(o, r.raw),
        s = i.add(i.multiply(n.raw, q), o),
        c = new dt(e.token.equals(this.token0) ? this.token1 : this.token0, i.divide(a, s));
    if (i.equal(c.raw, T)) throw new L();
    return [c, new t(n.add(e), r.subtract(c))];
  }, e.getInputAmount = function (e) {
    if (this.involvesToken(e.token) || u(!1), i.equal(this.reserve0.raw, T) || i.equal(this.reserve1.raw, T) || i.greaterThanOrEqual(e.raw, this.reserveOf(e.token).raw)) throw new X();
    var n = this.reserveOf(e.token),
        r = this.reserveOf(e.token.equals(this.token0) ? this.token1 : this.token0),
        o = i.multiply(i.multiply(r.raw, e.raw), q),
        a = i.multiply(i.subtract(n.raw, e.raw), O),
        s = new dt(e.token.equals(this.token0) ? this.token1 : this.token0, i.add(i.divide(o, a), g));
    return [s, new t(r.add(s), n.subtract(e))];
  }, e.getLiquidityMinted = function (t, e, n) {
    t.token.equals(this.liquidityToken) || u(!1);
    var r,
        o = e.token.sortsBefore(n.token) ? [e, n] : [n, e];
    if (o[0].token.equals(this.token0) && o[1].token.equals(this.token1) || u(!1), i.equal(t.raw, T)) r = i.subtract(J(i.multiply(o[0].raw, o[1].raw)), w);else {
      var a = i.divide(i.multiply(o[0].raw, t.raw), this.reserve0.raw),
          s = i.divide(i.multiply(o[1].raw, t.raw), this.reserve1.raw);
      r = i.lessThanOrEqual(a, s) ? a : s;
    }
    if (!i.greaterThan(r, T)) throw new L();
    return new dt(this.liquidityToken, r);
  }, e.getLiquidityValue = function (t, e, n, r, o) {
    var a;

    if (void 0 === r && (r = !1), this.involvesToken(t) || u(!1), e.token.equals(this.liquidityToken) || u(!1), n.token.equals(this.liquidityToken) || u(!1), i.lessThanOrEqual(n.raw, e.raw) || u(!1), r) {
      o || u(!1);
      var s = Y(o);
      if (i.equal(s, T)) a = e;else {
        var c = J(i.multiply(this.reserve0.raw, this.reserve1.raw)),
            d = J(s);

        if (i.greaterThan(c, d)) {
          var f = i.multiply(e.raw, i.subtract(c, d)),
              l = i.add(i.multiply(c, x), d),
              p = i.divide(f, l);
          a = e.add(new dt(this.liquidityToken, p));
        } else a = e;
      }
    } else a = e;

    return new dt(t, i.divide(i.multiply(n.raw, this.reserveOf(t).raw), a.raw));
  }, C(t, [{
    key: "token0Price",
    get: function get() {
      return new ft(this.token0, this.token1, this.tokenAmounts[0].raw, this.tokenAmounts[1].raw);
    }
  }, {
    key: "token1Price",
    get: function get() {
      return new ft(this.token1, this.token0, this.tokenAmounts[1].raw, this.tokenAmounts[0].raw);
    }
  }, {
    key: "chainId",
    get: function get() {
      return this.token0.chainId;
    }
  }, {
    key: "token0",
    get: function get() {
      return this.tokenAmounts[0].token;
    }
  }, {
    key: "token1",
    get: function get() {
      return this.tokenAmounts[1].token;
    }
  }, {
    key: "reserve0",
    get: function get() {
      return this.tokenAmounts[0];
    }
  }, {
    key: "reserve1",
    get: function get() {
      return this.tokenAmounts[1];
    }
  }]), t;
}(),
    ht = function () {
  function t(t, e, n) {
    t.length > 0 || u(!1), t.every(function (e) {
      return e.chainId === t[0].chainId;
    }) || u(!1), e instanceof K && t[0].involvesToken(e) || e === G && t[0].involvesToken(nt[t[0].chainId]) || u(!1), void 0 === n || n instanceof K && t[t.length - 1].involvesToken(n) || n === G && t[t.length - 1].involvesToken(nt[t[0].chainId]) || u(!1);

    for (var r, o = [e instanceof K ? e : nt[t[0].chainId]], i = j(t.entries()); !(r = i()).done;) {
      var a = r.value,
          s = a[1],
          c = o[a[0]];
      c.equals(s.token0) || c.equals(s.token1) || u(!1);
      var d = c.equals(s.token0) ? s.token1 : s.token0;
      o.push(d);
    }

    this.pairs = t, this.path = o, this.midPrice = ft.fromRoute(this), this.input = e, this.output = null != n ? n : o[o.length - 1];
  }

  return C(t, [{
    key: "chainId",
    get: function get() {
      return this.pairs[0].chainId;
    }
  }]), t;
}(),
    mt = new at(b),
    vt = function (t) {
  function e() {
    return t.apply(this, arguments) || this;
  }

  _(e, t);

  var n = e.prototype;
  return n.toSignificant = function (t, e, n) {
    return void 0 === t && (t = 5), this.multiply(mt).toSignificant(t, e, n);
  }, n.toFixed = function (t, e, n) {
    return void 0 === t && (t = 2), this.multiply(mt).toFixed(t, e, n);
  }, e;
}(at);

function yt(t, e) {
  return Z(t.inputAmount.currency, e.inputAmount.currency) || u(!1), Z(t.outputAmount.currency, e.outputAmount.currency) || u(!1), t.outputAmount.equalTo(e.outputAmount) ? t.inputAmount.equalTo(e.inputAmount) ? 0 : t.inputAmount.lessThan(e.inputAmount) ? -1 : 1 : t.outputAmount.lessThan(e.outputAmount) ? 1 : -1;
}

function wt(t, e) {
  var n = yt(t, e);
  return 0 !== n ? n : t.priceImpact.lessThan(e.priceImpact) ? -1 : t.priceImpact.greaterThan(e.priceImpact) ? 1 : t.route.path.length - e.route.path.length;
}

function Tt(t, e) {
  return t instanceof dt ? t : t.currency === G ? new dt(nt[e], t.raw) : void u(!1);
}

function gt(t, e) {
  return t instanceof K ? t : t === G ? nt[e] : void u(!1);
}

var kt = function () {
  function t(t, e, n) {
    var r,
        o,
        i,
        a = new Array(t.path.length),
        s = new Array(t.pairs.length);

    if (n === exports.TradeType.EXACT_INPUT) {
      Z(e.currency, t.input) || u(!1), a[0] = Tt(e, t.chainId);

      for (var c = 0; c < t.path.length - 1; c++) {
        var d = t.pairs[c].getOutputAmount(a[c]),
            f = d[1];
        a[c + 1] = d[0], s[c] = f;
      }
    } else {
      Z(e.currency, t.output) || u(!1), a[a.length - 1] = Tt(e, t.chainId);

      for (var l = t.path.length - 1; l > 0; l--) {
        var p = t.pairs[l - 1].getInputAmount(a[l]),
            h = p[1];
        a[l - 1] = p[0], s[l - 1] = h;
      }
    }

    this.route = t, this.tradeType = n, this.inputAmount = n === exports.TradeType.EXACT_INPUT ? e : t.input === G ? ct.ether(a[0].raw) : a[0], this.outputAmount = n === exports.TradeType.EXACT_OUTPUT ? e : t.output === G ? ct.ether(a[a.length - 1].raw) : a[a.length - 1], this.executionPrice = new ft(this.inputAmount.currency, this.outputAmount.currency, this.inputAmount.raw, this.outputAmount.raw), this.nextMidPrice = ft.fromRoute(new ht(s, t.input)), this.priceImpact = (r = this.outputAmount, i = (o = t.midPrice.raw.multiply(this.inputAmount.raw)).subtract(r.raw).divide(o), new vt(i.numerator, i.denominator));
  }

  t.exactIn = function (e, n) {
    return new t(e, n, exports.TradeType.EXACT_INPUT);
  }, t.exactOut = function (e, n) {
    return new t(e, n, exports.TradeType.EXACT_OUTPUT);
  };
  var e = t.prototype;
  return e.minimumAmountOut = function (t) {
    if (t.lessThan(T) && u(!1), this.tradeType === exports.TradeType.EXACT_OUTPUT) return this.outputAmount;
    var e = new at(g).add(t).invert().multiply(this.outputAmount.raw).quotient;
    return this.outputAmount instanceof dt ? new dt(this.outputAmount.token, e) : ct.ether(e);
  }, e.maximumAmountIn = function (t) {
    if (t.lessThan(T) && u(!1), this.tradeType === exports.TradeType.EXACT_INPUT) return this.inputAmount;
    var e = new at(g).add(t).multiply(this.inputAmount.raw).quotient;
    return this.inputAmount instanceof dt ? new dt(this.inputAmount.token, e) : ct.ether(e);
  }, t.bestTradeExactIn = function (e, n, r, o, i, a, s) {
    var c = void 0 === o ? {} : o,
        d = c.maxNumResults,
        f = void 0 === d ? 3 : d,
        l = c.maxHops,
        p = void 0 === l ? 3 : l;
    void 0 === i && (i = []), void 0 === a && (a = n), void 0 === s && (s = []), e.length > 0 || u(!1), p > 0 || u(!1), a === n || i.length > 0 || u(!1);
    var h = n instanceof dt ? n.token.chainId : r instanceof K ? r.chainId : void 0;
    void 0 === h && u(!1);

    for (var m = Tt(n, h), v = gt(r, h), y = 0; y < e.length; y++) {
      var w = e[y];

      if ((w.token0.equals(m.token) || w.token1.equals(m.token)) && !w.reserve0.equalTo(T) && !w.reserve1.equalTo(T)) {
        var g = void 0;

        try {
          g = w.getOutputAmount(m)[0];
        } catch (t) {
          if (t.isInsufficientInputAmountError) continue;
          throw t;
        }

        if (g.token.equals(v)) Q(s, new t(new ht([].concat(i, [w]), a.currency, r), a, exports.TradeType.EXACT_INPUT), f, wt);else if (p > 1 && e.length > 1) {
          var k = e.slice(0, y).concat(e.slice(y + 1, e.length));
          t.bestTradeExactIn(k, g, r, {
            maxNumResults: f,
            maxHops: p - 1
          }, [].concat(i, [w]), a, s);
        }
      }
    }

    return s;
  }, t.bestTradeExactOut = function (e, n, r, o, i, a, s) {
    var c = void 0 === o ? {} : o,
        d = c.maxNumResults,
        f = void 0 === d ? 3 : d,
        l = c.maxHops,
        p = void 0 === l ? 3 : l;
    void 0 === i && (i = []), void 0 === a && (a = r), void 0 === s && (s = []), e.length > 0 || u(!1), p > 0 || u(!1), a === r || i.length > 0 || u(!1);
    var h = r instanceof dt ? r.token.chainId : n instanceof K ? n.chainId : void 0;
    void 0 === h && u(!1);

    for (var m = Tt(r, h), v = gt(n, h), y = 0; y < e.length; y++) {
      var w = e[y];

      if ((w.token0.equals(m.token) || w.token1.equals(m.token)) && !w.reserve0.equalTo(T) && !w.reserve1.equalTo(T)) {
        var g = void 0;

        try {
          g = w.getInputAmount(m)[0];
        } catch (t) {
          if (t.isInsufficientReservesError) continue;
          throw t;
        }

        if (g.token.equals(v)) Q(s, new t(new ht([w].concat(i), n, a.currency), a, exports.TradeType.EXACT_OUTPUT), f, wt);else if (p > 1 && e.length > 1) {
          var k = e.slice(0, y).concat(e.slice(y + 1, e.length));
          t.bestTradeExactOut(k, n, g, {
            maxNumResults: f,
            maxHops: p - 1
          }, [w].concat(i), a, s);
        }
      }
    }

    return s;
  }, t;
}();

function At(t) {
  return "0x" + t.raw.toString(16);
}

var xt,
    It = function () {
  function t() {}

  return t.swapCallParameters = function (t, e) {
    var n = t.inputAmount.currency === G,
        r = t.outputAmount.currency === G;
    n && r && u(!1), e.ttl > 0 || u(!1);
    var o,
        i,
        a,
        s = V(e.recipient),
        c = At(t.maximumAmountIn(e.allowedSlippage)),
        d = At(t.minimumAmountOut(e.allowedSlippage)),
        f = t.route.path.map(function (t) {
      return t.address;
    }),
        l = "0x" + (Math.floor(new Date().getTime() / 1e3) + e.ttl).toString(16),
        p = Boolean(e.feeOnTransfer);

    switch (t.tradeType) {
      case exports.TradeType.EXACT_INPUT:
        n ? (o = p ? "swapExactETHForTokensSupportingFeeOnTransferTokens" : "swapExactETHForTokens", i = [d, f, s, l], a = c) : r ? (o = p ? "swapExactTokensForETHSupportingFeeOnTransferTokens" : "swapExactTokensForETH", i = [c, d, f, s, l], a = "0x0") : (o = p ? "swapExactTokensForTokensSupportingFeeOnTransferTokens" : "swapExactTokensForTokens", i = [c, d, f, s, l], a = "0x0");
        break;

      case exports.TradeType.EXACT_OUTPUT:
        p && u(!1), n ? (o = "swapETHForExactTokens", i = [d, f, s, l], a = c) : r ? (o = "swapTokensForExactETH", i = [d, c, f, s, l], a = "0x0") : (o = "swapTokensForExactTokens", i = [d, c, f, s, l], a = "0x0");
    }

    return {
      methodName: o,
      args: i,
      value: a
    };
  }, t;
}(),
    bt = [{
  constant: !0,
  inputs: [],
  name: "decimals",
  outputs: [{
    name: "",
    type: "uint8"
  }],
  payable: !1,
  stateMutability: "view",
  type: "function"
}, {
  constant: !0,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "balanceOf",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: !1,
  stateMutability: "view",
  type: "function"
}],
    Ot = ((xt = {})[exports.ChainId.MUMBAI] = {
  "0xE0B7927c4aF23765Cb51314A0E0521A9645F0E2A": 9
}, xt),
    qt = function () {
  function t() {}

  return t.fetchTokenData = function (t, e, n, r, o) {
    try {
      var i,
          u,
          a = function a(n) {
        return new K(t, e, n, r, o);
      };

      void 0 === n && (n = h.getDefaultProvider(p.getNetwork(t)));
      var s = "number" == typeof (null === (i = Ot) || void 0 === i || null === (u = i[t]) || void 0 === u ? void 0 : u[e]);
      return Promise.resolve(s ? a(Ot[t][e]) : Promise.resolve(new l.Contract(e, bt, n).decimals().then(function (n) {
        var r, o, i;
        return Ot = P({}, Ot, ((i = {})[t] = P({}, null === (r = Ot) || void 0 === r ? void 0 : r[t], ((o = {})[e] = n, o)), i)), n;
      })).then(a));
    } catch (t) {
      return Promise.reject(t);
    }
  }, t.fetchPairData = function (t, e, n) {
    try {
      void 0 === n && (n = h.getDefaultProvider(p.getNetwork(t.chainId))), t.chainId !== e.chainId && u(!1);
      var r = pt.getAddress(t, e);
      return Promise.resolve(new l.Contract(r, m.abi, n).getReserves()).then(function (n) {
        var r = n[0],
            o = n[1],
            i = t.sortsBefore(e) ? [r, o] : [o, r];
        return new pt(new dt(t, i[0]), new dt(e, i[1]));
      });
    } catch (t) {
      return Promise.reject(t);
    }
  }, t;
}();

exports.JSBI = i, exports.Currency = z, exports.CurrencyAmount = ct, exports.ETHER = G, exports.FACTORY_ADDRESS = "0x5757371414417b8C6CAad45bAeF941aBc7d3Ab32", exports.Fetcher = qt, exports.Fraction = at, exports.INIT_CODE_HASH = y, exports.InsufficientInputAmountError = L, exports.InsufficientReservesError = X, exports.MINIMUM_LIQUIDITY = w, exports.Pair = pt, exports.Percent = vt, exports.Price = ft, exports.Route = ht, exports.Router = It, exports.Token = K, exports.TokenAmount = dt, exports.Trade = kt, exports.WETH = nt, exports.currencyEquals = Z, exports.inputOutputComparator = yt, exports.tradeComparator = wt;